import { use_slice_generation, use_slice_grid2d } from '@/hooks/store/use_slices';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { useMemo } from 'react';
import { WATCHER_GRID2D__get__generation_current } from '../../../watchers/grid2d/WATCHER_GRID2D__get__generation_current';
import { GRID2D__fixed_generation } from '../../views/GRID2D__fixed_generation';
import { GRID2D__fixed_generation_same_images } from '../../views/GRID2D__fixed_generation_same_images';
import { GRID2D__loading } from '../../views/GRID2D__loading';

export function GRID2D_generation_current() {
  const { generation_current } = use_slice_generation(['generation_current']);
  const { grids2d_map } = use_slice_grid2d(['grids2d_map']);

  const grid2d = useMemo(() => get_grid2d(), [generation_current, grids2d_map]);

  const grid_contains_many_same_images = useMemo(() => get_grid_contains_many_same_images(), [grid2d]);

  /*
   * EFFECTS
   */

  function get_grid2d() {
    //wait for load grid from server
    if (!grids2d_map.has(generation_current._id)) return DTO__grid2d.CREATE_STUB();

    let out = grids2d_map.get_or_assert(generation_current._id);

    return out.clone();
  }

  function get_grid_contains_many_same_images() {
    if (grid2d.is_stub()) return false;
    if (grid2d.total_cells_amount == 1) return false;
    if (grid2d.total_images_amount != grid2d.total_cells_amount) return false;

    let cells = grid2d.cells__get_list();

    let is_any_empty_cell = cells.some(cell => cell.hash_sha256_content.is_empty_hash_sha256());
    if (is_any_empty_cell) return false;

    let hashes_set = new Set<string>();

    for (let cell of cells) {
      let { hash_sha256_content } = cell;

      hashes_set.add(hash_sha256_content);

      if (hashes_set.size > 1) break; // no need to continue
    }

    return hashes_set.size == 1;
  }

  /*
   * RENDERS
   */

  function render_grid() {
    if (grid2d.is_stub()) return <GRID2D__loading entity={generation_current} />;

    return grid_contains_many_same_images ? <GRID2D__fixed_generation_same_images {...{ grid2d }} /> : <GRID2D__fixed_generation {...{ grid2d }} />;
  }

  /*
   * HTML
   */

  return (
    <>
      <WATCHER_GRID2D__get__generation_current />
      {render_grid()}
    </>
  );
}
